import clsx from "clsx"
import { type ReactElement, memo } from "react"
import { Card } from "@/ui/Card"
import { type IPlayerCardList } from "./types"

export const PlayerCardList = memo(function PlayerCardList({
  items,
  isMatchActive,
  player,
  refIsMyTurn,
  refIsMatchActive,
  onDiscard,
  onActivateCard,
  onViewCard
}: IPlayerCardList): ReactElement[] {
  return items.map((el) => (
    <Card
      {...el}
      dataFlipId={`card-${el.id}`}
      className={clsx("box", el.status)}
      isMatchActive={isMatchActive}
      refIsMyTurn={refIsMyTurn}
      refIsMatchActive={refIsMatchActive}
      player={player}
      onClose={() => onDiscard(el)}
      onActivateCard={() => onActivateCard(el)}
      onClick={() => onViewCard(el.data)}
      key={`card-${el.id}`}
    >
      {el.id}
    </Card>
  ))
})
